import ARROW_DOWN from "@/assets/icons/arrow-down.svg";
import "./style.scss";
import { FC, useEffect, useState } from "react";

interface PaginationPropTypes {
  activePage: number;
  totalPage: number;
  onChange?: (currPage: number) => void;
}

const Pagination: FC<PaginationPropTypes> = ({
  activePage,
  totalPage,
  onChange = () => {},
}) => {
  const paginationListLimit = 8;
  const [paginationList, setPaginationList] = useState<number[]>([]);

  useEffect(() => {
    const temp: any = [];

    for (let i = 1; i <= totalPage; i += 1) {
      if (temp.length !== paginationListLimit) {
        temp.push(i);
      }
    }

    setPaginationList(temp);
  }, [totalPage]);

  const onPrev = () => {
    const currPage = activePage - 1;

    if (currPage >= 1) {
      onChange(currPage);

      if (paginationList.indexOf(currPage) === -1) {
        let temp = [];
        for (let i = currPage; i <= totalPage; i += 1) {
          if (temp.length !== paginationListLimit) {
            temp.push(i);
          }
        }

        setPaginationList(temp);
      }
    }
  };

  const onClickPagination = (page: any) => {
    onChange(page);
  };

  const onNext = () => {
    const currPage = activePage + 1;

    if (currPage <= totalPage) {
      onChange(currPage);

      if (paginationList.indexOf(currPage) === -1) {
        let temp = [];
        for (let i = currPage; i >= 0; i -= 1) {
          if (temp.length !== paginationListLimit) {
            temp.push(i);
          }
        }

        temp = temp.reverse();
        setPaginationList(temp);
      }
    }
  };

  return (
    <div className="pagination-component-wrapper">
      <button className="navigation-btn" onClick={onPrev}>
        <img className="previous-icon" src={ARROW_DOWN} alt="previous-icon" />
        <span>Previous</span>
      </button>

      <div className="pagination-list">
        {paginationList.length && paginationList[0] !== 1 && (
          <div className="pagination-number">...</div>
        )}

        {paginationList.map((num: any, index: any) => (
          <div
            key={index}
            className={
              "pagination-number" + (num === activePage ? " active" : "")
            }
            onClick={() => onClickPagination(num)}
          >
            {num}
          </div>
        ))}

        {paginationList.length &&
          paginationList[paginationList.length - 1] !== totalPage && (
            <div className="pagination-number">...</div>
          )}
      </div>

      <button className="navigation-btn" onClick={onNext}>
        <span>Next</span>
        <img className="next-icon" src={ARROW_DOWN} alt="next-icon" />
      </button>
    </div>
  );
};

export default Pagination;
